import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config";
import useLogout from "../Auth/useLogout";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";
import NumberFormatter from "../../Component/NumberFormatter";

export default function TransporterBelt() {
    const [loading, setLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const [beltList, setBeltList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [selectedState, setSelectedState] = useState("");
    const [cityList, setCityList] = useState([]);
    const [beltEnrties, setBeltEntries] = useState([]);
    const [loadingAddress, setLoadingAddress] = useState("");

    const logout = useLogout();

    const fetchBelt = useCallback(async () => {
        setDataLoading(true);
        try {
            const response = await axios.get(`${config.apiUrl}/transporter/belt`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: config.token,
                    Accept: "application/json",
                },
            });

            setBeltList(response.data.list);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                logout();
            }
        } finally {
            setDataLoading(false);
        }
    }, [logout]);

    useEffect(() => {
        fetchBelt();
    }, [fetchBelt]);

    const getBeltState = async () => {
        try {
            const response = await axios.get(`${config.apiUrl}/transporter/state`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: config.token,
                    Accept: "application/json",
                },
            });
            setStateList(response.data.state_list);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };

    const getBeltCity = async (e) => {
        const state = e.target.value;
        if (state) {
            try {
                const response = await axios.get(
                    `${config.apiUrl}/transporter/city/${state}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: config.token,
                            Accept: "application/json",
                        },
                    }
                );
                setSelectedState(state);
                setCityList(response.data.city_list);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    logout();
                }
            }
        }
    };

    const addBeltEntry = (e) => {
        const city = e.target.value;

        if (city && selectedState) {
            const newEnrty = {
                state: selectedState,
                city: city,
                min_price: "",
                max_price: "",
            };

            const exists = beltEnrties.some((entry) => entry.city === city);
            if (!exists) {
                setBeltEntries((prev) => [...prev, newEnrty]);
            } else {
                toast.error("Please select a different city", {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }
    };

    const beltPriceChange = (e, index, price_type) => {
        const updateEntry = [...beltEnrties];
        if (index !== null && price_type === "min_price") {
            updateEntry[index].min_price = e.target.value;
        }
        if (index !== null && price_type === "max_price") {
            updateEntry[index].max_price = e.target.value;
        }
        setBeltEntries(updateEntry);
    };

    const beltEnrtyDelete = (index) => {
        const updateEntry = beltEnrties.filter((_, i) => i !== index);
        setBeltEntries(updateEntry);
    };

    const loadingAddressChange = (e) => {
        setLoadingAddress(e.target.value);
    };

    const resetBeltData = () => {
        setStateList([]);
        setSelectedState("");
        setCityList([]);
        setBeltEntries([]);
        setLoadingAddress("");
    };

    const handleBeltSubmit = async (e) => {
        e.preventDefault();
        const notvalidted = beltEnrties.some(
            (item) => !item.city || !item.city || !item.min_price || !item.max_price
        );
        if (notvalidted || !loadingAddress) {
            toast.error("Please fill all fields", {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            setLoading(true);
            try {
                const selectedCity = [];
                const minPrice = {};
                const maxPrice = {};

                beltEnrties.forEach((item) => {
                    const cityKey = item.city;
                    selectedCity.push(cityKey);

                    minPrice[cityKey.toLowerCase().replace(/\s+/g, "_")] = item.min_price;
                    maxPrice[cityKey.toLowerCase().replace(/\s+/g, "_")] = item.max_price;
                });

                const response = await axios.post(
                    `${config.apiUrl}/transporter/assign-belt`,
                    {
                        loading_address: loadingAddress,
                        selected_city: selectedCity,
                        min_price: minPrice,
                        max_price: maxPrice,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: config.token,
                            Accept: "application/json",
                        },
                    }
                );
                toast.success(response.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                const closeBtn = document.getElementById("belt_close");
                resetBeltData();
                closeBtn.click();
                fetchBelt();
            } catch (error) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                if (error.response && error.response.status === 401) {
                    logout();
                }
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <>
            {dataLoading ? (
                <div className="d-flex justify-content-center">
                    <Dataloader />
                </div>
            ) : (
                <>
                    <div className="row">
                        <div className="col-lg-12 text-end">
                            <button
                                className="add-edit-btn mb-1 w_sm_100"
                                data-bs-toggle="modal"
                                data-bs-target="#beltmodal"
                                onClick={getBeltState}
                            >
                                <i className="bi bi-plus-lg"></i>Add New Belt
                            </button>
                        </div>
                    </div>
                    {beltList.length > 0 ? (
                        <div className="row g-3">
                            {beltList.map((belt, index) => (
                                <div className="col-lg-4 px-2" key={index}>
                                    <div className="order-product align-items-center">
                                        <div className="order-detail">
                                            <div className="head">
                                                <h6>Loading Address:</h6>
                                                <p>{belt.loading_address}</p>
                                            </div>
                                            <div className="body">
                                                <h6>Unloading Address:</h6>
                                                <div className="table-responsive">
                                                    <table className="chart-table table table-bordered mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th>State</th>
                                                                <th>City</th>
                                                                <th>Min Price</th>
                                                                <th>Max Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {belt.unloading_address.map(
                                                                (address, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{address.state}</td>
                                                                        <td>{address.city}</td>
                                                                        <td>
                                                                            Rs{" "}
                                                                            <NumberFormatter
                                                                                number={address.min_price}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            Rs{" "}
                                                                            <NumberFormatter
                                                                                number={address.max_price}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="abs_check">
                                            <div className="number_badge">{index + 1}</div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <NoData />
                    )}
                </>
            )}

            {/**Belt Modal */}
            <div
                className="modal fade"
                id="beltmodal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="beltmodalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                    <div className="modal-content custom-modal">
                        <div className="header">
                            <h5 className="title">Add New Belt</h5>
                            <button
                                type="button"
                                className="custom-btn bg-warning rounded-2 text-dark"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                id="belt_close"
                                onClick={resetBeltData}
                            >
                                Cancel
                            </button>
                        </div>

                        <div className="body">
                            <form onSubmit={handleBeltSubmit}>
                                <div className="row g-3">
                                    <div className="col-lg-12">
                                        <label htmlFor="loading_address" className="form-label">
                                            Loading Address
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="loading_address"
                                            value={loadingAddress}
                                            onChange={loadingAddressChange}
                                            placeholder="Enter loading address"
                                        />
                                    </div>
                                    <div className="col-lg-12 bg-light">
                                        <label className="text-secondary ps-2 py-1">
                                            Select the state and city to add price*
                                        </label>
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="state" className="form-label">
                                            Select State
                                        </label>
                                        <select
                                            className="form-control"
                                            onChange={getBeltCity}
                                            required
                                        >
                                            <option value="">Select State</option>
                                            {stateList.map((state, index) => (
                                                <option key={index} value={state}>
                                                    {state}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="city" className="form-label">
                                            Select City
                                        </label>
                                        <select
                                            className="form-control"
                                            onChange={addBeltEntry}
                                            required
                                        >
                                            <option value="">Select City</option>
                                            {cityList.map((city, index) => (
                                                <option key={index} value={city}>
                                                    {city}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="table-responsive mt-1">
                                            <table className="chart-table table table-bordered mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>State</th>
                                                        <th>City</th>
                                                        <th>Min Price</th>
                                                        <th>Max Price</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {beltEnrties.length > 0 ? (
                                                        beltEnrties.map((entry, index) => (
                                                            <tr key={index}>
                                                                <td>{entry.state}</td>
                                                                <td>{entry.city}</td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={entry.min_price}
                                                                        onChange={(e) =>
                                                                            beltPriceChange(e, index, "min_price")
                                                                        }
                                                                        placeholder="Enter price"
                                                                        onWheel={(e) => e.target.blur()}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        value={entry.max_price}
                                                                        onChange={(e) =>
                                                                            beltPriceChange(e, index, "max_price")
                                                                        }
                                                                        placeholder="Enter price"
                                                                        onWheel={(e) => e.target.blur()}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className="btn-danger fs-5"
                                                                        onClick={() => beltEnrtyDelete(index)}
                                                                    >
                                                                        <i className="bi bi-x-lg"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={5} className="text-center">
                                                                No data found!
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-1">
                                    <div className="col-lg-12 text-end">
                                        <button
                                            type="submit"
                                            title="Update Profile"
                                            className="submit_btn"
                                            disabled={loading}
                                        >
                                            <i className="bi bi-floppy"></i>
                                            {loading ? "Submitting" : "Submit"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
